import { render, staticRenderFns } from "./sensor-input.vue?vue&type=template&id=0ba98ba2&"
import script from "./sensor-input.vue?vue&type=script&lang=js&"
export * from "./sensor-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports